import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PackagePlanButtonComponent } from '../button/button.component';
import { PackagePlan } from '../../../model/PackagePlan';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-price-plan-buttons',
  standalone: true,
  imports: [CommonModule, PackagePlanButtonComponent],
  templateUrl: './buttons.component.html',
  styleUrl: './buttons.component.scss'
})
export class PricePlanButtonsComponent {
  @Input() plans: PackagePlan[] = [];
  @Output() selectPackagePlan = new EventEmitter<PackagePlan>();

  async onButtonClick(plan: PackagePlan): Promise<void> {
    console.log(`Button clicked for plan ${plan.name}`);
    this.selectPackagePlan.emit(plan);
  }
}
